/**
 * Help + Reference page. Mirrors the legacy `helpreference.blade.php` view: a
 * centered heading plus the FlexStorm intro video. Replaces the previous
 * (incorrect) link target that pointed at the cost-engine "My defaults" page.
 */
import { BynderVideo } from '../lib/BynderVideo';

export function HelpReferencePage() {
  return (
    <div className="container-fluid mt-2">
      <div className="row mt-3">
        <div className="col-12 text-center">
          <h1>See How the ADS FlexStorm Project Planner Works</h1>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-xl-9 col-xxl-9">
          <BynderVideo mediaId="53B94EFC-F714-4F97-97AB902903859A2E" />
        </div>
      </div>
    </div>
  );
}
